export const MINDMAP_LAYOUT_KINDS = ["default", "compact", "flat", "dash", "solid", "invert", "draw"] as const;
export type MindmapLayoutKind = (typeof MINDMAP_LAYOUT_KINDS)[number];

export const DEFAULT_MINDMAP_LAYOUT_KIND: MindmapLayoutKind = "default";
